import { startOfYear, subYears, endOfYear } from 'date-fns'
import { CalendarEntry } from '../types'
import { formatSameYear } from '../formatters'
import { isValidDate, isValidInput } from '../validators'
import { InvalidCountInputError, InvalidDateError } from '../errors'
import normalizeDate from '../normalize-date'

export const getYearsBefore = (date: Date, count: number, locale?: Locale): CalendarEntry => {
  // Validate the date input
  if (!isValidDate(date)) {
    throw InvalidDateError
  }

  // Validate the count input
  if (!isValidInput(count)) {
    throw InvalidCountInputError
  }

  let from = date
  let to = date

  if (count == 0) {
    from = startOfYear(from)
  } else {
    from = startOfYear(subYears(from, count))
    to = endOfYear(subYears(to, 1))
  }

  const formatted = formatSameYear(from, to, locale)

  return {
    from: normalizeDate(from),
    to: normalizeDate(to),
    formatted
  }
}
